import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { State } from 'src/app/store';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Collection } from 'src/app/global/services/collections/collections.model';
import { CreateCollectionAction, CreateCollectionSuccessAction, CreateCollectionErrorAction } from 'src/app/global/store/global.actions';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-collection-configuration',
    templateUrl: './collection-configuration.component.html',
    styleUrls: ['./collection-configuration.component.scss'],
})
export class CollectionConfigurationComponent implements OnDestroy {
    destroy$ = new Subject();

    submitLoading = false;

    constructor(
        private router: Router,
        private store: Store<State>,
        private actions$: Actions,
    ) {}

    handleSubmit(payload: Collection): void {
        this.submitLoading = true;
        this.store.dispatch(CreateCollectionAction({ collection: payload }));

        this.actions$
            .pipe(
                ofType(CreateCollectionSuccessAction, CreateCollectionErrorAction),
                tap(() => (this.submitLoading = false)),
                ofType(CreateCollectionSuccessAction),
                tap(() => this.router.navigate(['collections'])),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
